export function addHttps(url) {
    if (url) {
        if (url.startsWith('http://')) {
            return url.replace('http://', 'https://');
        }
        if (url.startsWith('//')) {
            return `https:${url}`;
        }
    }
    return url;
}
//# sourceMappingURL=add-https.js.map